export const RangosActionTypes = {
  API_RESPONSE_SUCCESS: '@@rangos-edad/API_RESPONSE_SUCCESS',
  API_RESPONSE_ERROR: '@@rangos/API_RESPONSE_ERROR',

  GET_RANGO: '@@rangos-edad/GET_RANGO',
  LIST_RANGOS: '@@rangos-edad/LIST_RANGOS',
  ADD_RANGO: '@@rangos-edad/ADD_RANGO',
  UPDATE_RANGO: '@@rangos-edad/UPDATE_RANGO',
  UPDATE_RANGOS: '@@rangos-edad/UPDATE_RANGOS',
  DELETE_RANGO: '@@rangos-edad/DELETE_RANGO',

  RESET: '@@rangos-edad/RESET',
  RESET_SOFT: '@@rangos-edad/RESET_SOFT'
}
